






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StateViewModel } from '@/features/bots/models/designer';
import { appsApi } from '@/features/apps/shared/services/apps';
import { Action, Getter } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { InstalledApp } from '@/features/apps/shared/models';
import CapableAppModal from '@/shared/components/capableAppPicker/CapableAppModal.vue';
import IslandBadge from './IslandBadge.vue';
import { botsApi } from '../../services/bots';
import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card } from '@/shared/components/cardRenderer';
import {AppCard} from '@/features/apps/shared/models/appCard';
import { BotAppInitViewModel } from '@/features/bots/models/request/botAppInitViewModel';
import { DELETE_STATE } from '@/store/bot-designer/states/actionTypes';
import ContentHighlightsEditModal from '@/shared/components/contentHighlights/ContentHighlightsEditModal.vue';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';

@Component({
	components: {
		CapableAppModal,
		IslandBadge,
		CardRenderer,
		EditIcon,
		ContentHighlightsEditModal
	}
})
export default class AppIntegrationComponent extends Vue {
	@Prop() public value: StateViewModel;
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(DELETE_STATE) public removeState: (stateToRemove: StateViewModel) => void;

	public actionColour = '#062B80';
	public card: Card | null = null;
	public capableApps: InstalledApp[] = [];
	public showModal: boolean = false;
	public isLoading: boolean = false;
	public showAppEditModal = false;

	public state: StateViewModel = {
		id: '',
		component: 'AppIntegration'
	};

	@Watch('value', {immediate: true})
	public onValueChanged(value: StateViewModel, previous: StateViewModel) {
		this.state = value;
	}

	public async created() {
		this.isLoading = true;
		await this.initialiseApps();
	}

	public close() {
		this.showModal = false;

		if (!this.state.appAction) {
			this.removeState(this.state);
		}
	}

	public async renderAppPreview(installedAppId: string, config: any) {
		this.isLoading = true;

		this.state.appAction = {
			installedAppId,
			config
		};

		try {
			const request = { config } as BotAppInitViewModel;
			const appInitData = await botsApi.botAppInit(this.currentWorkspace.id, installedAppId, request);
			if (this.isPanelComponentsValid(appInitData.card)) {
				this.state.appAction.preview = JSON.stringify(appInitData.card.components);
				this.card = { id: appInitData.id, content: appInitData.card };
			}
		} catch {
			// just carry on
		} finally {
			this.isLoading = false;
		}

		this.$emit('state-updated', this.state);
	}

	public getSelectedAppDescription() {
		let app: InstalledApp | undefined;
		if (this.state.appAction && this.state.appAction) {
			const installedAppId = this.state.appAction.installedAppId;
			app = this.capableApps.find(a => a.installedAppId === installedAppId);
		}

		if (!app) {
			return '';
		}

		return app.name;
	}

	public configRequest(workspaceId: string, installedAppId: string, values: any, storedData: any, componentId: any) {
		return botsApi.botAppConfig(workspaceId, installedAppId, values, storedData, componentId);
	}

	public handleAppSave(app: ConfiguredAppIntegration) {
		this.showAppEditModal = false;
		this.state.appAction = app;
		this.renderAppPreview(this.state.appAction.installedAppId, this.state.appAction.config);
		this.$emit('state-updated', this.state);
	}

	public openAppEditModal() {
		this.showAppEditModal = true;
	}

	public shouldShowEditButton() {
		const contentHighlightsApp = this.capableApps.find(app => app.appId === 'contenthighlights');

		if (!contentHighlightsApp) {
			return false;
		}

		return this.value.appAction?.installedAppId === contentHighlightsApp.installedAppId;
	}

	private async initialiseApps() {
		try {
			const apps = await appsApi.getCapableApps(this.currentWorkspace.id, ['botActions']);
			this.capableApps = apps.map(app => app as InstalledApp);
			if (!this.state.appAction) {
				this.showModal = true;
			} else {
				if (this.state.appAction.preview) {
					this.card = {
						id: this.state.appAction.installedAppId,
						content: {
							components: JSON.parse(this.state.appAction.preview)
						}
					};
				}
			}
		} finally {
			this.isLoading = false;
		}
	}

	private isPanelComponentsValid(panel: AppCard) {
		return panel && panel.components && panel.components.length > 0;
	}
}
